import React from 'react';
import './Specializedinject.css';
import petImage from '../../../imgs/specialiinject.webp'; 

const Specializedinject = () => {
  return (
    <div className="sepcial-card">
      <div className="sepcial-imgsc" data-aos="fade-down">
        <img src={petImage} alt="PET Preform" />
      </div>
      <div className="sepcial-card-right" data-aos="fade-down">
        <h2>Specialized for PET Preforms Injection Molding</h2>
        <p>Faster and more stable PET preform production solutions</p>
        <ul>
          <li>3 to 5 seconds shorter cycle time</li>
          <li>30% lower production costs</li>
          <li>PET-specificated screw for high-quality preforms</li>
        </ul>
      </div>
    </div>
  );
};

export default Specializedinject;
